import flatMap from "lodash/flatMap";
import map from "lodash/map";
import { apiClientMeilisearch } from "../../../lib/client-api";
import { Mapper } from "../../../lib/utils/mapper";
import type { ProductSearchQueryDto } from "./dto/product-search-query.dto";
import { ProductSearchResponseDto } from "./dto/product-search-response.dto";

const MULTI_SEARCH_ENDPOINT = "/multi-search";

export async function multiSearchProductIdentifiers(queries: ProductSearchQueryDto[]): Promise<string[]> {
  const response = await apiClientMeilisearch.post<ProductSearchResponseDto>(MULTI_SEARCH_ENDPOINT, { queries });
  const responseDto = Mapper.mapData(ProductSearchResponseDto, response.data);

  return flatMap(responseDto.results, function toUniqueIdentifiers(result) {
    return map(result.hits, "uniqueIdentifier");
  });
}
